import styles from "./ByMe.module.css"
const ByMe=()=>{
    return <>
    <div className={styles.byMe}>נבנה על ידי <a  href="https://danielrozenblat.co.il/"  rel="noopener noreferrer" target="_blank" className={styles.a}>דניאל רוזנבלט</a></div>
    </>
}
export default ByMe
